export default class B2BVariantSyncer extends HTMLElement {
  constructor() {
    super();

    /** @type {string | undefined} */
    this.productId = this.dataset.productId;

    /** @type {string | undefined} */
    this.variantSku = this.dataset.variantSku;

    /** @type {HTMLElement | null} */
    this.closestSection = null;
  }

  connectedCallback() {
    const shouldInitComponent = !!(typeof window.spark !== 'undefined' && this.productId && this.variantSku);

    if (!shouldInitComponent) return;

    this.closestSection = this.closest(`.shopify-section, dialog`);
    this.init();
  }

  async init() {
    const variant = await window.spark.getVariant(this.productId, this.variantSku);

    if (!variant) return;

    const { rrp } = variant;
    const currencyCode = variant?.price?.currencyCode == 'eur' ? '€' : '$';

    const rrpWrapper = this.closestSection?.querySelector(`[data-product-rrp-wrapper]`);
    const rrpValueWrapper = this.closestSection?.querySelector(`[data-product-rrp-value]`);

    if (rrpWrapper && rrpValueWrapper) {
      rrpWrapper.toggleAttribute('hidden', !rrp || !currencyCode);
      if (rrp && currencyCode) {
        rrpValueWrapper.textContent = `${rrp.toFixed(2).replace('.', ',')} ${currencyCode}`;
      }
    }

    const deliveryDateEl = this.closestSection?.querySelector(`[data-product-delivery-date]`);

    if (deliveryDateEl instanceof HTMLElement) {
      deliveryDateEl.style.display = variant.stockStatus === 'backorder' ? 'block' : 'none';
    }
  }
}

if (!customElements.get('b2b-variant-syncer')) {
  customElements.define('b2b-variant-syncer', B2BVariantSyncer);
}
